import InputSliderBlock, {
  InputSliderBlockValue,
} from 'components/Shared/SearchFilter/InputSliderBlock';
import useEvents from 'lib/hooks/useEvents';
import { useFilterContext } from 'contexts/OnboardingFilterContext';
import { useEffect } from 'react';
import viewEvent from 'lib/Tracking/Onboarding/ViewEvent';
import { SourcePages } from 'lib/EventSchema';
import styles from './styles';
import AutolistLogo from '../Logo';
import Button from '../Button';
import { OnboardingComponentProps } from '../Modal';

const Year = ({ t, onNextStep }: OnboardingComponentProps): JSX.Element => {
  const maxModelYear: number = new Date().getFullYear() + 1;
  const logger = useEvents();
  const { filterData, updateFilterData } = useFilterContext();

  useEffect(() => {
    logger.log(viewEvent({ sourcePage: SourcePages.OnboardingYear }));
  }, [logger]);

  const onChange = (val: InputSliderBlockValue): void => {
    updateFilterData({
      Year: {
        ...filterData.Year,
        ...val,
      },
    });
  };

  return (
    <>
      <div className="budget-step-container">
        <div className="budget-content">
          <AutolistLogo />
          <div className="header">{t('onboarding.yearScreen.header')}</div>
          <div className="subtitle">{t('onboarding.yearScreen.subText')}</div>
          <div className="slider-container">
            <InputSliderBlock
              onChange={onChange}
              minAllowed={1940}
              maxAllowed={maxModelYear}
              initialMin={1940}
              initialMax={maxModelYear}
              minPlaceholder={'Pre 1940'}
              maxPlaceholder={maxModelYear.toString()}
              pushable={false}
              step={1}
              hasThousandSeparator={false}
              getMinPrefix={({ isFocused, numericValue }): string | undefined => {
                if (isFocused) {
                  return undefined;
                }
                return numericValue && numericValue <= 1940 ? 'Pre ' : undefined;
              }}
            />
          </div>
        </div>
        <div>
          <Button
            onClick={(): void => {
              onNextStep({
                min_year: filterData.Year?.min,
                max_year: filterData.Year?.max,
              });
            }}
          >
            {t('onboarding.next')}
          </Button>
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default Year;
